(function () {
  function moneyText(el) {
    if (!el) return "";
    return (el.textContent || "").trim();
  }

  // 不靠文案：稳定定位 groups container
  function getGroupsContainer(wrapper) {
    return wrapper.querySelector(".bsub-widget__groups-container");
  }

  // 不靠文案：Subscribe group = 有 data-bsub-selling-plan-group-id
  function getSubscribeGroupAndId(groupsContainer) {
    const subscribeGroup = groupsContainer.querySelector(
      ".bsub-widget__group[data-bsub-selling-plan-group-id]"
    );
    const groupId = subscribeGroup?.getAttribute("data-bsub-selling-plan-group-id") || "";
    return { subscribeGroup, groupId };
  }

  // 不靠文案：One-time = input value="once"
  function getOneTimeGroup(groupsContainer) {
    return (
      groupsContainer.querySelector(
        'input[name="bsub-selling-plan-group"][value="once"]'
      )?.closest(".bsub-widget__group") || null
    );
  }
  // ---- Variant price resolver (follows selected variant) ----
let __bsubVariantPriceMap = null;
let __bsubVariantMapLoading = false;

function getProductHandleFromURL() {
  const m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
  return m ? m[1] : null;
}

async function ensureVariantPriceMap() {
  if (__bsubVariantPriceMap || __bsubVariantMapLoading) return;
  const handle = getProductHandleFromURL();
  if (!handle) return;

  __bsubVariantMapLoading = true;
  try {
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    __bsubVariantPriceMap = new Map();
    (data.variants || []).forEach(v => {
      __bsubVariantPriceMap.set(String(v.id), v.price); // cents
    });
  } catch (e) {
    __bsubVariantPriceMap = null;
  } finally {
    __bsubVariantMapLoading = false;
  }
}

function getCurrentVariantId() {
  // 1) 最稳：很多主题切换 variant 会更新 URL ?variant=xxxx
  const urlVid = new URLSearchParams(window.location.search).get("variant");
  if (urlVid) return String(urlVid);

  // 2) 常规：product form hidden input[name=id]
  const idInput =
    document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
    document.querySelector('input[name="id"]');

  if (!idInput) return "";
  // 有些主题只更新 attribute，有些只更新 property
  return String(idInput.value || idInput.getAttribute("value") || "");
}

function formatMoneyFromCents(cents) {
  const n = Number(cents);
  if (!Number.isFinite(n)) return "";

  if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
    const fmt = window.Shopify.money_format || "${{amount}}";
    return window.Shopify.formatMoney(n, fmt);
  }

  return `$${(n / 100).toFixed(2)}`;
}

async function getRetailPriceFromCurrentVariant() {
  await ensureVariantPriceMap();
  const vid = getCurrentVariantId();
  if (!vid || !__bsubVariantPriceMap) return "";
  const cents = __bsubVariantPriceMap.get(vid);
  if (cents == null) return "";
  return formatMoneyFromCents(cents);
}

async function getRetailPriceFromHiddenSpan() {
  // 最优先：按当前 variant id 获取（会随变体变化）
  const v = await getRetailPriceFromCurrentVariant();
  if (v) return v;

  // 兜底：仍然尝试 hidden span（如果你未来会更新它）
  const s = document.querySelector("#bsub-retail-price");
  const txt = (s && s.textContent ? s.textContent : "").trim();
  return txt || "";
}

  // 不靠文案：订阅价来自 options-container 当前选中的 delivery option 的 data-bsub-per-delivery-price
  function getCurrentSelectedPlanPrice(wrapper, groupId) {
    if (!groupId) return "";

    const options = wrapper.querySelector(
      `.bsub-options-container[data-bsub-selling-plan-group-id="${groupId}"]`
    );
    if (!options) return "";

    const checked = options.querySelector("input[data-bsub-delivery-frequency-option]:checked");
    if (!checked) return "";

    const priceSpan = checked
    .closest("label")
    ?.querySelector("[data-bsub-per-delivery-price], .bsub-widget__plan-pricing [data-bsub-per-delivery-price], .bsub-widget__plan-pricing span:nth-child(1)");

    return moneyText(priceSpan);
  }

  function buildCustomUI(wrapper) {
    // 防止重复渲染
    if (wrapper.querySelector(".bsub-custom-ui")) return true;

    const groupsContainer = getGroupsContainer(wrapper);
    if (!groupsContainer) return false;

    const { subscribeGroup: subscribe, groupId } = getSubscribeGroupAndId(groupsContainer);
    const onetime = getOneTimeGroup(groupsContainer);
    if (!subscribe || !onetime || !groupId) return false;

    // 频率容器：options-container（你的 DOM 是这个，不是 plans-container）
    const optionsContainer = wrapper.querySelector(
      `.bsub-options-container[data-bsub-selling-plan-group-id="${groupId}"]`
    );
    if (!optionsContainer) return false;

    // 找到原生 group 的 radio input（用于同步选择）
    const subscribeInput = subscribe.querySelector("input[type='radio']");
    const onetimeInput = onetime.querySelector("input[type='radio']");
    if (!subscribeInput || !onetimeInput) return false;

    // options 的 inputs（delivery frequency）
    const planInputs = Array.from(
      optionsContainer.querySelectorAll("input[data-bsub-delivery-frequency-option]")
    );
    if (!planInputs.length) return false;

    // 隐藏原生 UI（保留 DOM 用于 Bold 逻辑）
    groupsContainer.style.display = "none";
    optionsContainer.style.display = "none";

    // Custom UI root
    const ui = document.createElement("div");
    ui.className = "bsub-custom-ui";

    // Subscribe Card
    const subCard = document.createElement("div");
    subCard.className = "bsub-card bsub-card-subscribe";

    subCard.innerHTML = `
      <div class="bsub-card-price">
        <span data-role="sub-price"></span>
        <span data-role="sub-compare" class="bsub-compare-price"></span>
      </div>
      <div class="bsub-card-head">
        <div class="bsub-radio-dot" data-role="sub-dot"></div>
        <div>
          <div class="bsub-card-title">Auto-Ship Subscription</div>
          <div class="bsub-card-subtitle">Easy Repeat Deliveries - Enjoy Bigger Savings</div>
        </div>
      </div>

      <div class="bsub-sub-box">
        <div class="bsub-benefits">

            <div class="bsub-benefit">
              <span class="bsub-icon">💰</span>
              <span>Keep saving on every order</span>
            </div>

            <div class="bsub-benefit">
              <span class="bsub-icon">📅</span>
              <span>Get deliveries on your schedule</span>
            </div>

            <div class="bsub-benefit">
              <span class="bsub-icon">✏️</span>
              <span>Skip, change, or cancel anytime</span>
            </div>

      </div>

      </div>

      <div class="bsub-get-every">Get it every</div>
      <div class="bsub-tiles-row" data-role="tiles"></div>
    `;

    // One-time Card
    const oneCard = document.createElement("div");
    oneCard.className = "bsub-card bsub-card-onetime";
    oneCard.innerHTML = `
      <div class="bsub-card-price" data-role="one-price"></div>
      <div class="bsub-card-head">
        <div class="bsub-radio-dot"></div>
        <div>
          <div class="bsub-card-title" style="color:#111">One-time purchase</div>
        </div>
      </div>
    `;

    ui.appendChild(subCard);
    ui.appendChild(oneCard);

    // 插入到 wrapper 顶部
    wrapper.insertBefore(ui, wrapper.firstChild);

    // --- Move Bold collapsible details right under Subscribe card (so it won't appear under One-time) ---
    const collapsible = wrapper.querySelector(".bsub__collapsible-wrapper");
    if (collapsible) {
  // 把详情块插到自定义 Subscribe 卡片后面
  subCard.insertAdjacentElement("afterend", collapsible);
    }

    // Build frequency tiles based on original options radios
    const tilesHost = subCard.querySelector("[data-role='tiles']");

    planInputs.forEach((inp) => {
      // 你的 DOM: label > input + .bsub-widget__plan-header
      const header = inp.closest("label")?.querySelector(".bsub-widget__plan-header");
      const fullText =
        header?.querySelector(".bsub-widget__main-text")?.textContent?.trim() ||
        inp.value ||
        "";

      const isRec = fullText.toLowerCase().includes("most popular") ||
                    fullText.toLowerCase().includes("recommended");

      const tile = document.createElement("div");
      tile.className = "bsub-tile";
      tile.dataset.for = inp.value || ""; // 这里用 value 更稳（你的 input 没有 id）

      tile.innerHTML = `
        ${isRec ? `<div class="badge">Recommended</div>` : ``}
        <div class="main">${fullText}</div>
      `;

      tile.addEventListener("click", () => {
        // 选中 subscribe
        subscribeInput.click();
        // 选中对应 frequency
        inp.click();
        syncState();
      });

      tilesHost.appendChild(tile);
    });

    // Click subscribe card selects subscribe
    subCard.addEventListener("click", (e) => {
      if (e.target.closest(".bsub-tile") || e.target.closest("[data-role='how']")) return;
      subscribeInput.click();
      syncState();
    });

    // Click one-time card selects one-time
    oneCard.addEventListener("click", () => {
      onetimeInput.click();
      syncState();
    });

    // How it works：触发 Bold 自带详情按钮（存在就点）
    const how = subCard.querySelector("[data-role='how']");
    how.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const btn = wrapper.querySelector(".bsub-widget__toggle-details-btn");
      if (btn) btn.click();
    });

    async function syncState() {
      // selected styles
      if (subscribeInput.checked) {
        subCard.classList.add("selected");
        oneCard.classList.remove("selected");
      } else {
        subCard.classList.remove("selected");
        oneCard.classList.add("selected");
      }

      // prices
      const subPrice = getCurrentSelectedPlanPrice(wrapper, groupId);
      subCard.querySelector("[data-role='sub-price']").textContent = subPrice || "";

      const onePrice = await getRetailPriceFromHiddenSpan();
      oneCard.querySelector("[data-role='one-price']").textContent = onePrice || "";

      // subscribe 右上角显示划线 one-time（retail）价
      const compareEl = subCard.querySelector("[data-role='sub-compare']");
      if (compareEl) {
        compareEl.textContent = (subPrice && onePrice) ? onePrice : "";
      }

      // tiles selected state: 找到 optionsContainer 当前 checked 的 value
      const checkedPlan = optionsContainer.querySelector("input[data-bsub-delivery-frequency-option]:checked");
      const checkedValue = checkedPlan ? (checkedPlan.value || "") : "";

      const tiles = Array.from(wrapper.querySelectorAll(".bsub-custom-ui .bsub-tile"));
      tiles.forEach(t => t.classList.remove("selected"));

      if (checkedValue) {
        const match = tiles.find(t => t.dataset.for === checkedValue);
        if (match) match.classList.add("selected");
      }
    }

    // 预热 variant map（提升第一次显示速度）
    ensureVariantPriceMap();

    // 初次同步
    syncState();

    // --- Ensure subscription price is populated on initial load (Bold injects price async) ---
    (async function ensureInitialPrices(){
      // 尝试最多 30 次（约 1.5 秒），直到能读到订阅价
      for (let i = 0; i < 30; i++) {
        const subPrice = getCurrentSelectedPlanPrice(wrapper, groupId);
        if (subPrice) {
          await syncState();
          return;
        }
        // 如果订阅价还没注入，轻触发一次当前 frequency（不改变用户选择）
        const checked = optionsContainer.querySelector("input[data-bsub-delivery-frequency-option]:checked");
        if (checked) checked.dispatchEvent(new Event("change", { bubbles: true }));
        await new Promise(r => setTimeout(r, 50));
      }
      // 最后再同步一次（即便为空，也不会卡住）
      await syncState();
    })();

    // --- Listen to variant id changes (so one-time price updates without refresh) ---
    (function watchVariantIdChange(){
      const idInput =
        document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('input[name="id"]');

      if (!idInput) return;

      let last = String(idInput.value || "");

      // 1) MutationObserver: some themes update attribute "value"
      const mo = new MutationObserver(() => {
        const now = String(idInput.value || idInput.getAttribute("value") || "");
        if (now && now !== last) {
          last = now;
          // 变体变了，刷新 one-time 价格
          setTimeout(syncState, 0);
        }
      });
      mo.observe(idInput, { attributes: true, attributeFilter: ["value"] });

      // 2) Poll fallback: some themes only update the property, not the attribute
      setInterval(() => {
        const now = String(idInput.value || "");
        if (now && now !== last) {
          last = now;
          setTimeout(syncState, 0);
        }
      }, 250);

      // 3) Common theme custom events (Dawn etc.)
      document.addEventListener("variant:change", () => setTimeout(syncState, 0));
      document.addEventListener("product:variant-change", () => setTimeout(syncState, 0));
    })();
    // --- Universal variant watcher (fast): watches getCurrentVariantId() so it works even if DOM is rebuilt ---
    (function universalVariantWatcher(){
      let lastVid = getCurrentVariantId();

      const tick = () => {
        const nowVid = getCurrentVariantId();
        if (nowVid && nowVid !== lastVid) {
          lastVid = nowVid;
          // 立刻同步，确保价格正确
          syncState();
        }
      };

      // 更快轮询（体感更即时）
      setInterval(tick, 60);

      // 监听 URL 变化（很多主题用 pushState/replaceState 更新 ?variant=）
      const _ps = history.pushState;
      history.pushState = function () {
        _ps.apply(this, arguments);
        tick();
      };
      const _rs = history.replaceState;
      history.replaceState = function () {
        _rs.apply(this, arguments);
        tick();
      };
      window.addEventListener("popstate", tick);

      // 初次触发一次
      tick();
    })();
    // Bold inputs change 时同步 UI（包括 frequency & purchase option）
    wrapper.addEventListener("change", (e) => {
      if (e.target && e.target.matches("input[type='radio']")) {
        // 延迟一拍，确保 Bold 更新完 checked 状态
        setTimeout(syncState, 0);
      }
    });

    return true;
  }

  function init() {
    const wrapper = document.querySelector(".bsub-widget__wrapper");
    if (!wrapper) return false;
    return buildCustomUI(wrapper);
  }

  if (init()) return;

  // Bold 动态渲染/切换变体可能会重建 DOM
  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();